<template>
  <div class='SaleCardPriceSet'>
    <search-form size='medium'
                 labelWidth='90px'
                 :searchData="search.searchData"
                 :searchForm="search.searchForm"
                 :searchHandle="search.searchHandle"
                 :searchHandleSpan="search.searchHandleSpan">
    </search-form>
    <Table :TableParam="Table">
      <template v-slot:adjustAmount="{ item }">
        <div>{{ item.adjustAmount }} {{ item.adjustType ? '%' : '元' }}</div>
      </template>
      <template v-slot:status="{ item }">
        <div> {{ item.status == 0 ? '失效' : '有效' }}</div>
      </template>
      <template v-slot:handle="item">
        <el-link type="primary"
                 @click="()=>invalid(item.item)" v-if="item.item.status == 1">失效</el-link>
      </template>
      <template v-slot:Paging>
        <Paging @change="getItemList"
                :pager="pager" />
      </template>
    </Table>
    <Dialog :show.sync="isShow"
            v-if="isShow"
            title="新建"
            @handle="confirmFun">
      <template v-slot:dialogContent>
        <el-form ref="form" :model="addForm" :rules="rules" label-width="100px">
          <el-form-item label="卡类型：" prop="cardTypeId">
            <el-select v-model="addForm.cardTypeId" placeholder="请选择卡类型" style="width: 100%">
              <el-option
                v-for="item in typeOptions"
                :key="item.id"
                :label="item.name"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="费用设定：" prop="adjustAmount">
            <el-input v-model="addForm.adjustAmount" type="number">
              <el-select v-model="addForm.adjustType" slot="append" placeholder="请输入" style="width: 80px">
                <el-option
                  v-for="item in unitOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-input>
          </el-form-item>
        </el-form>
      </template>
    </Dialog>
  </div>
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
// 例如：import 《组件名称》 from '《组件路径》';
import SearchForm from '@/components/SearchForm'
import Table from '@/components/Table'
import Paging from '@/components/Paging'
import Dialog from '@/components/Dialog'
import { optionsDataReplace } from '@/utils'
import { handleCofirm } from '@/utils'
export default {
  // import引入的组件需要注入到对象中才能使用
  components: {
    SearchForm,
    Table,
    Paging,
    Dialog
  },
  data () {
    // 这里存放数据
    return {
      pager: { // 翻页
        page: 1,
        rows: 10,
        count: 0
      },

      search: { // 搜索
        searchData: {}, // 返回的数据
        searchForm: [
          { type: 'Select', label: '卡类型：', prop: 'cardTypeId', width: '180px', options: [], props: this.$map.typeProps, change: row => '', placeholder: '请选择卡类型' },
        ],
        searchHandle: [
          { label: '查询', type: 'primary', handle: () => this.searchHandleForm() },
        ],
      },
      typeOptions: [],
      isShow: false,
      addForm: {
        cardTypeId: '',
        adjustAmount: '',
        adjustType: 1
      },
      rules: {
        cardTypeId: [{ required: true, message:'请选择卡类型', trigger: 'change' }],
        adjustAmount: [{ required: true, message:'请输入', trigger: 'blur' }]
      },
      unitOptions: [
        { label: '%', value: 1 },
        { label: '金额', value: 0 }
      ],
      Table: { // 表格
        handle: true,
        paddingRight: true,
        primaryBtn: {
          show: true,
          html: '新增',
          handle: this.addFun
        },
        data: [],
        column: [
          { prop: 'cardTypeName', label: '卡类型' },
          { prop: 'adjustAmount', label: '费用设定', slot: true },
          { prop: 'status', label: '状态', slot: true },
          { prop: 'adjustTime', label: '生效时间' },
        ]
      }
    }
  },
  created(){
    this.init()
  },
  // 监听属性 类似于data概念
  computed: {},
  // 监控data中的数据变化
  watch: {},
  // 方法集合
  methods: {
    invalid(item) {
      handleCofirm('确认当前操作?', 'type').then(async () => {
            this.$http.cardTypeAmountRecordInvalidApi(item.id)
            .then((res) => {
            if (res.status === 200) {
                this.getItemList()
                this.$message.success(res.msg || '操作成功')
            }
            }).catch((err)=>{
                this.$message.error(res.msg)
            })
        }).catch(() => { 

        })
    },
    searchHandleForm () {
      this.pager.page = 1
      this.pager.rows = 10
      this.getItemList()
    },
    // 新增
    addFun () {
      this.addForm = {
        cardTypeId: '',
        adjustAmount: '',
        adjustType: 1
      }
      this.isShow = true
    },
    confirmFun () {
      this.$refs.form && this.$refs.form.validate(valid => {
        if(valid) {
          const data = this.addForm
          this.$http.setSaleCardPriceApi(data).then(() => {
            this.getItemList()
            this.isShow = false
          })
        }
      })
    },
    // 列表
    getItemList () {
      const { pager, search } = this
      const params = {
        pageNum: pager.page,
        pageSize: pager.rows,
        ...search.searchData
      }
       this.$http.getCardPriceListApi(params).then(res => {
         if(res.status === 200) {
            this.pager.count = res.data.total
            this.Table.data = res.data.list
         }
       })
    },
    // 卡类型
    async getCardTypeList () {
      const res = await this.$http.getCardTypeList()
      if(res && res.status === 200) {
        this.typeOptions = res.data
        optionsDataReplace('cardTypeId', this.search.searchForm, (res.data || []))
      }
    },
    init () {
      this.getItemList()
      this.getCardTypeList()
    }
  }
}
</script>
<style lang='scss' scoped>
//@import url(); 引入公共css类
.SaleCardPriceSet {
  ::v-deep input::-webkit-outer-spin-button,
  ::v-deep input::-webkit-inner-spin-button {
    -webkit-appearance: none !important;
  }
}
</style>
